
import {Component, Vue, Prop,Watch} from "vue-property-decorator";

@Component({
  name: "singleSelect",
})

export default class extends Vue {
  @Prop({default: () => ''}) private defaultSelected: string;
  @Prop({default: () => []}) private defaultOptions: [];
  @Prop({default: () => ''}) private type: '';


  private selected = '';

  created() {
    this.selected = this.defaultSelected;
  }
  @Watch('selected')
  private onSelectedChange() {
    this.getSelected();
  }

   @Watch('defaultSelected')
  private onDefaultSelectedChange() {
    this.selected = this.defaultSelected;
  }

  private getSelected() {
    this.$emit("selected", this.selected, this.type);
  }
}

